module.exports = __webpack_public_path__ + "img/betadine.bce1b4bf.jpg";